/**
 * AdminSection — sección del panel admin con encabezado colorido y profesional.
 * Uso:
 *   <AdminSection icon={Gear} title="General" subtitle="Datos básicos de la plataforma"
 *                 color="amber" action={<button>...</button>}>
 *     ...contenido...
 *   </AdminSection>
 *
 * Colores disponibles: amber, emerald, sky, violet, rose, cyan, orange
 */
const COLORS = {
  amber:   { badge: "linear-gradient(135deg,#F59E0B,#D97706)", glow: "rgba(245,158,11,0.25)",  text: "#FCD34D", border: "rgba(245,158,11,0.22)" },
  emerald: { badge: "linear-gradient(135deg,#10B981,#059669)", glow: "rgba(16,185,129,0.25)",  text: "#6EE7B7", border: "rgba(16,185,129,0.22)" },
  sky:     { badge: "linear-gradient(135deg,#0EA5E9,#0284C7)", glow: "rgba(14,165,233,0.25)",  text: "#7DD3FC", border: "rgba(14,165,233,0.22)" },
  violet:  { badge: "linear-gradient(135deg,#8B5CF6,#6D28D9)", glow: "rgba(139,92,246,0.25)",  text: "#C4B5FD", border: "rgba(139,92,246,0.22)" },
  rose:    { badge: "linear-gradient(135deg,#F43F5E,#BE123C)", glow: "rgba(244,63,94,0.25)",   text: "#FDA4AF", border: "rgba(244,63,94,0.22)" },
  cyan:    { badge: "linear-gradient(135deg,#06B6D4,#0E7490)", glow: "rgba(6,182,212,0.25)",   text: "#67E8F9", border: "rgba(6,182,212,0.22)" },
  orange:  { badge: "linear-gradient(135deg,#F97316,#C2410C)", glow: "rgba(249,115,22,0.25)",  text: "#FDBA74", border: "rgba(249,115,22,0.22)" },
};

export default function AdminSection({
  icon: Icon,
  title,
  subtitle,
  color = "amber",
  action,
  children,
  className = "",
  testid,
}) {
  const c = COLORS[color] || COLORS.amber;
  return (
    <section
      className={`rounded-2xl overflow-hidden ${className}`}
      {...(testid ? { "data-testid": testid } : {})}
      style={{
        background: "rgba(255,255,255,0.025)",
        border: `1px solid ${c.border}`,
        boxShadow: `0 0 32px -12px ${c.glow}`,
      }}
    >
      <div
        className="flex items-center justify-between gap-3 px-5 py-4"
        style={{ borderBottom: `1px solid ${c.border}`, background: `linear-gradient(90deg, ${c.glow}, transparent 70%)` }}
      >
        <div className="flex items-center gap-3 min-w-0">
          {Icon && (
            <span
              className="flex-shrink-0 w-9 h-9 rounded-xl flex items-center justify-center"
              style={{ background: c.badge, boxShadow: `0 4px 14px -4px ${c.glow}` }}
            >
              <Icon weight="fill" className="w-5 h-5 text-white" />
            </span>
          )}
          <div className="min-w-0">
            <h2 className="font-black text-base leading-tight" style={{ color: c.text }}>{title}</h2>
            {subtitle && <p className="text-xs text-zinc-400 mt-0.5 truncate">{subtitle}</p>}
          </div>
        </div>
        {action}
      </div>
      <div className="p-5 space-y-4">
        {children}
      </div>
    </section>
  );
}
